<footer class="footer-area footer-bg2 pt-100" *ngIf="footerData">
    <div class="container">
        <div class="footer-midal pb-70">
            <div class="row">
                <div class="col-lg-4 col-sm-7">
                    <div class="footer-widget">
                        <div class="footer-img" routerLink="">
                            <img src="assets/img/logo/ringpilot_logo.png" alt="RingPilot-logo">
                        </div>
                        <p style="color: white;">{{footerData.companyInfo.description}}</p>
                        <div class="footer-social-icon">
                            <ul class="social-link">
                                <li *ngFor="let social of footerData.socialLinks">
                                    <a [href]="social.link" target="_blank">
                                        <i [class]="social.icon"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>                        
                    </div>
                </div>

                <div class="col-lg-3 col-sm-7">
                    <div class="footer-widget pl-5">
                        <h3>Quick Links</h3>
                        <ul class="footer-list">
                            <li *ngFor="let link of footerData.quickLinks">
                                <a [routerLink]="link.link">{{link.title}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-2 col-sm-5">
                    <div class="footer-widget">
                        <h3>Services</h3>
                        <ul class="footer-list">
                            <li *ngFor="let service of footerData.services">
                                <a [routerLink]="service.link">{{service.title}}</a>
                            </li>
                            <li><app-sitemap-generator></app-sitemap-generator></li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-3 col-sm-5">
                    <div class="footer-widget">
                        <h3>Contact Info</h3>
                        <ul class="footer-list-two">
                            <li>
                                <i class='flaticon-telephone'></i>
                                <a [href]="'tel:' + footerData.companyInfo.phone">{{footerData.companyInfo.phone}}</a>
                            </li>
                            <li>
                                <i class='flaticon-email-1'></i>
                                <a [href]="'mailto:' + footerData.companyInfo.email">{{footerData.companyInfo.email}}</a>
                            </li>
                            <li>
                                <i class='flaticon-place'></i>
                                {{footerData.companyInfo.address}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <hr class="bg-white border-0" style="height: 1px;">
        <div class="copy-right-area">
            <div class="row">
                <div class="col-lg-8">
                    <div class="copy-right-text text-center">
                        <p>© {{currentYear}} Designed & Developed by <a href="https://ringpilot.com/">RINGPILOT</a></p>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="copy-right-list">
                        <ul>
                            <li><a routerLink="/privacy-policy"> Privacy Policy</a></li>
                            <li><a routerLink="/terms-conditions"> Terms & Conditions</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>